




import React, { useState, useEffect } from "react";
import "../assets/Cibil/CibilReport.css";
import { useSelector, useDispatch } from "react-redux";

import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePdf, faSortUp } from "@fortawesome/free-solid-svg-icons";
import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";
import { toast } from "react-toastify";


export default function CibilCheck() {
  const dispatch = useDispatch();
    const { profile } = useSelector((state) => state.userProfile);
  const [reports, setReports] = useState([]);
  const [search, setSearch] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  // DEFAULT EMAIL (Replace with logged-in user email)
  const EMAIL = "aa2microfinance@gmail.com";



  
    useEffect(() => {
      dispatch(fetchUserProfile());
    }, [dispatch]);
  

  // useEffect(() => {
  //   fetchCibilReports();
  // }, []);



  
    useEffect(() => {
      if (profile?.id)  fetchCibilReports();
    }, [profile]);
  
  // ---------------------------
  // Fetch Report List API
  // ---------------------------
  const fetchCibilReports = async (page = 1, searchText = "") => {
    setIsLoading(true);

    try {
      const res = await axios.get(
        `https://payyug.in/api/cibil-reports/website?email=${profile.email}&search=${searchText}&page=${page}&limit=10`
      );

      if (res.data.success) {
        setReports(res.data.data);
        setTotalPages(res.data.totalPages || 1);
      }
    } catch (err) {
      console.log("Error loading report list", err);
    } finally {
      setIsLoading(false);
    }
  };


// ---- Dynamic PDF Password ----
const generatePassword = () => {
  const id = profile?.id || "00000";

  const date = new Date();
  const year = date.getFullYear();
  const month = date.toLocaleString("en-US", { month: "short" });

  return `10189${month}${year}`;
};

const pdfPassword = generatePassword();

const copyPassword = () => {
  navigator.clipboard.writeText(pdfPassword);
  alert("Password copied: " + pdfPassword);
};


  // ---------------------------
  // Search Submit
  // ---------------------------
  const handleSearch = (e) => {
    e.preventDefault();
    setCurrentPage(1);
    fetchCibilReports(1, search);
  };

  // ---------------------------
  // FETCH PDF BY ID
  // ---------------------------
  const openPdfById = async (id) => {
    try {
      const res = await axios.get(`https://payyug.in/api/cibil-reports/pdf/${id}`);

      if (!res.data.success) return alert("PDF not found!");

const pdfBase64 = res.data.pdf || res.data.data;

      const pdfWindow = window.open("");
      pdfWindow.document.write(
        `<iframe width='100%' height='100%' src='data:application/pdf;base64,${pdfBase64}'></iframe>`
      );
    } catch (err) {
      console.log("PDF Error", err);
      toast.error("Error loading PDF");
    }
  };

  // ---------------------------
  // Pagination
  // ---------------------------
  const goPrev = () => {
    if (currentPage > 1) {
      const newPage = currentPage - 1;
      setCurrentPage(newPage);
      fetchCibilReports(newPage, search);
    }
  };

  const goNext = () => {
    if (currentPage < totalPages) {
      const newPage = currentPage + 1;
      setCurrentPage(newPage);
      fetchCibilReports(newPage, search);
    }
  };

  return (
    <div className="cibil-report-container">
      <h1>CIBIL REPORT HISTORY</h1>

      {/* Search Box */}
      <form className="cibil-search-box" onSubmit={handleSearch}>
        <div className="search-input-wrapper">
          <input
            type="text"
            placeholder="🔍 Search by name..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <button type="submit" className="search-btn">Search</button>
        </div>
      </form>

<div style={{
    display: "flex",
    justifyContent: "flex-end",
    marginBottom: "10px"
}}>
  <h4 
    style={{ 
      cursor: "pointer",
      background: "#f0f0f0",
      padding: "8px 12px",
      borderRadius: "6px",
      fontWeight: "bold"
    }}
    onClick={copyPassword}
    title="Click to copy"
  >
    PDF Password: {pdfPassword}
  </h4>
</div>


      {/* Table */}
      <div className="cibil-wrap-table-wrapper">
        <table className="cibil-wrap-table">
          <thead>
            <tr>
              <th>SN <FontAwesomeIcon icon={faSortUp} /></th>
              <th>Name</th>
              <th>DOB</th>
              <th>PAN</th>
              <th>Aadhar</th>
              <th>Generated On</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {isLoading ? (
              <tr>
                <td colSpan="7" style={{ textAlign: "center" }}>Loading...</td>
              </tr>
            ) : reports.length === 0 ? (
              <tr>
                <td colSpan="7" style={{ textAlign: "center" }}>No reports found</td>
              </tr>
            ) : (
              reports.map((item, index) => {
                const createdAt = item.createdAt
                  ? new Date(item.createdAt).toLocaleDateString()
                  : "-";

                return (
                  <tr key={item.id}>
                    <td>{(currentPage - 1) * 10 + (index + 1)}</td>
                    <td>{item.fullName}</td>
                    <td>{new Date(item.dob).toLocaleDateString("en-GB")||"N/A"}</td>
                    <td>{item.panCard}</td>
                    <td>{item.aadhaarNumber}</td>
                    <td>{new Date(createdAt).toLocaleDateString("en-GB")||"N/A"}</td>

                    <td>
                      <button
                        className="view-btn"
                        onClick={() => openPdfById(item.id)}
                      >
                        <FontAwesomeIcon icon={faFilePdf} /> View
                      </button>
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className="cibil-pagination">
        <button className="pagination-btn" disabled={currentPage === 1} onClick={goPrev}>
          ⬅ Prev
        </button>

        <span className="pagination-info">
          Page {currentPage} of {totalPages}
        </span>

        <button className="pagination-btn" disabled={currentPage === totalPages} onClick={goNext}>
          Next ➡
        </button>
      </div>
    </div>
  );
}
